// extracted by mini-css-extract-plugin
export default {"login":"Login_login__3cJrA","buttonWrapper":"Login_buttonWrapper__TFl4R"};